import * as tslib_1 from "tslib";
import Paper from '../Paper';
var PopoverContent = Paper.extend(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  max-height: calc(100% - 16px);\n  overflow-y: auto;\n  overflow-x: hidden;\n  margin: 8px;\n"], ["\n  max-height: calc(100% - 16px);\n  overflow-y: auto;\n  overflow-x: hidden;\n  margin: 8px;\n"])));
export default PopoverContent;
var templateObject_1;
//# sourceMappingURL=PopoverContent.js.map